import React, { Component } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

const RANDEVU_DETAY_API = 'https://randevuapi.uzmdrzelihaaksoy.com/randevu';
const RANDEVU_SIL_API = 'https://randevuapi.uzmdrzelihaaksoy.com/randevu-sil';
const RANDEVU_HATIRLATMA_API = 'https://randevuapi.uzmdrzelihaaksoy.com/randevu-hatirlatma';

const DURUM_ETIKET = {
  planlandi: { label: 'Planlandı', className: 'bg-sky-100 text-sky-700' },
  iptal: { label: 'İptal Edildi', className: 'bg-red-100 text-red-600' },
  tamamlandi: { label: 'Tamamlandı', className: 'bg-emerald-100 text-emerald-700' }
};

function formatTarih(tarih) {
  const [y, m, d] = tarih.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric', weekday: 'long' });
}

function isAdmin() {
  try {
    const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    return Array.isArray(roles) && roles.includes('administrator');
  } catch (err) {
    return false;
  }
}

class Randevu extends Component {

  constructor(props) {
    super(props);

    this.auth = localStorage.getItem('auth');

    this.state = {
      loading: true,
      error: '',
      randevu: null,
      deleting: false,
      deleteError: '',
      confirmingDelete: false,
      sendingReminder: false,
      reminderMessage: '',
      reminderError: ''
    };

    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleDeleteCancel = this.handleDeleteCancel.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleSendReminder = this.handleSendReminder.bind(this);
  }

  handleBack() {
    this.props.history.goBack();
  }

  componentDidMount() {
    const { uuid } = this.props.match.params;

    axios.get(`${RANDEVU_DETAY_API}/${uuid}`, { headers: { Authorization: 'Basic ' + this.auth } })
      .then(response => {
        this.setState({ randevu: response.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false, error: 'Randevu bulunamadı.' });
      });
  }

  handleSendReminder() {
    const { uuid } = this.props.match.params;

    this.setState({ sendingReminder: true, reminderMessage: '', reminderError: '' });

    axios.post(`${RANDEVU_HATIRLATMA_API}/${uuid}`, {}, { headers: { Authorization: 'Basic ' + this.auth } })
      .then(() => {
        this.setState({ sendingReminder: false, reminderMessage: 'Hatırlatma e-postası gönderildi.' });
      })
      .catch(error => {
        const message = error.response && error.response.data && error.response.data.message;
        this.setState({ sendingReminder: false, reminderError: message || 'Hatırlatma e-postası gönderilemedi.' });
      });
  }

  handleDeleteClick() {
    this.setState({ confirmingDelete: true, deleteError: '' });
  }

  handleDeleteCancel() {
    this.setState({ confirmingDelete: false });
  }

  handleDeleteConfirm() {
    const { uuid } = this.props.match.params;

    this.setState({ deleting: true, deleteError: '' });

    axios.delete(`${RANDEVU_SIL_API}/${uuid}`, { headers: { Authorization: 'Basic ' + this.auth } })
      .then(() => {
        this.props.history.push('/gelecek-randevular');
      })
      .catch(error => {
        const message = error.response && error.response.data && error.response.data.message;
        this.setState({ deleting: false, confirmingDelete: false, deleteError: message || 'Randevu silinemedi. Lütfen tekrar deneyiniz.' });
      });
  }

  render() {
    const { loading, error, randevu, deleting, deleteError, confirmingDelete, sendingReminder, reminderMessage, reminderError } = this.state;
    const { uuid } = this.props.match.params;
    const durum = randevu && (DURUM_ETIKET[randevu.durum] || { label: randevu.durum, className: 'bg-slate-100 text-slate-600' });

    return (
      <div className="max-w-lg mx-auto space-y-7">
        <header className="space-y-3">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-slate-900">Randevu Detayı</h1>
          <button
            type="button" onClick={this.handleBack}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"></path></svg>
            Geri
          </button>
        </header>

        {loading && <p className="text-sm text-slate-500">Yükleniyor...</p>}
        {error && <p className="text-sm text-red-500">{error}</p>}

        {!loading && !error && randevu && (
          <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100 overflow-hidden">
            <div className="px-4 py-3 flex items-center justify-between">
              <span className="text-sm text-slate-500">Hasta</span>
              <span className="text-sm font-medium text-slate-800">{randevu.hasta_adi}</span>
            </div>
            <div className="px-4 py-3 flex items-center justify-between">
              <span className="text-sm text-slate-500">Tarih</span>
              <span className="text-sm font-medium text-slate-800 capitalize">{formatTarih(randevu.tarih)}</span>
            </div>
            <div className="px-4 py-3 flex items-center justify-between">
              <span className="text-sm text-slate-500">Saat</span>
              <span className="text-sm font-medium text-slate-800 tabular-nums">{randevu.saat}</span>
            </div>
            <div className="px-4 py-3 flex items-center justify-between">
              <span className="text-sm text-slate-500">Durum</span>
              <span className={`text-xs font-semibold px-2 py-1 rounded-full ${durum.className}`}>{durum.label}</span>
            </div>
            {randevu.aciklama && (
              <div className="px-4 py-3">
                <span className="text-sm text-slate-500 block mb-1">Detay</span>
                <p className="text-sm text-slate-800 whitespace-pre-wrap">{randevu.aciklama}</p>
              </div>
            )}
            {randevu.olusturan && (
              <div className="px-4 py-3 flex items-center justify-between">
                <span className="text-sm text-slate-500">Ekleyen</span>
                <span className="text-sm font-medium text-slate-800">{randevu.olusturan}</span>
              </div>
            )}
          </div>
        )}

        {!loading && !error && randevu && (
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={this.handleSendReminder}
              disabled={sendingReminder || !randevu.hasta_eposta}
              className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md border border-slate-200 bg-white text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              {sendingReminder ? 'Gönderiliyor...' : 'Hatırlatma Gönder'}
            </button>
            {!randevu.hasta_eposta && (
              <span className="text-xs text-slate-400">Hastanın e-postası kayıtlı değil</span>
            )}
          </div>
        )}

        {reminderMessage && <p className="text-sm text-emerald-600">{reminderMessage}</p>}
        {reminderError && <p className="text-sm text-red-500">{reminderError}</p>}

        {deleteError && <p className="text-sm text-red-500">{deleteError}</p>}

        <div className="flex gap-3">
          <NavLink
            to="/gelecek-randevular"
            className="flex-1 h-10 px-4 rounded-md border border-slate-200 bg-white text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors inline-flex items-center justify-center"
          >
            Geri
          </NavLink>
          {!loading && !error && randevu && (
            <NavLink
              to={`/randevu-duzenle/${uuid}`}
              className="flex-1 h-10 px-4 rounded-md bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium shadow-sm transition-colors inline-flex items-center justify-center"
            >
              Düzenle
            </NavLink>
          )}
          {!loading && !error && randevu && isAdmin() && !confirmingDelete && (
            <button
              type="button"
              onClick={this.handleDeleteClick}
              className="flex-1 h-10 px-4 rounded-md bg-red-600 hover:bg-red-700 text-white text-sm font-medium shadow-sm transition-colors inline-flex items-center justify-center"
            >
              Sil
            </button>
          )}
        </div>

        {confirmingDelete && (
          <div className="rounded-xl border border-red-200 bg-red-50 p-4 space-y-3">
            <p className="text-sm text-red-700">Bu randevuyu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.</p>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={this.handleDeleteCancel}
                disabled={deleting}
                className="flex-1 h-10 px-4 rounded-md border border-slate-200 bg-white text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
              >
                Vazgeç
              </button>
              <button
                type="button"
                onClick={this.handleDeleteConfirm}
                disabled={deleting}
                className="flex-1 h-10 px-4 rounded-md bg-red-600 hover:bg-red-700 text-white text-sm font-medium shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
              >
                {deleting ? 'Siliniyor...' : 'Evet, Sil'}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Randevu
